import { render } from "./CheckboxGroup.vue?vue&type=template&id=1e515d36&scoped=true"
import script from "./CheckboxGroup.vue?vue&type=script&lang=js"
export * from "./CheckboxGroup.vue?vue&type=script&lang=js"

import "./CheckboxGroup.vue?vue&type=style&index=0&id=1e515d36&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e515d36"]])

export default __exports__